import Alert from '../Alert'
import Confirm from '../Confirm'
import Prompt from '../Prompt'
import Loading from '../Loading'
import Toast from '../Toast'
import Notify from '../Notify'
import {install} from './util'

const AlertPlugin = {
  install: install('$alert', Alert),
}

const ConfirmPlugin = {
  install: install('$confirm', Confirm),
}

const PromptPlugin = {
  install: install('$prompt', Prompt),
}

const LoadingPlugin = {
  install: install('$loading', Loading),
}

const ToastPlugin = {
  install: install('$toast', Toast),
}

const NotifyPlugin = {
  install: install('$notify', Notify),
}

export {
  AlertPlugin,
  ConfirmPlugin,
  PromptPlugin,
  LoadingPlugin,
  ToastPlugin,
  NotifyPlugin,
}



// WEBPACK FOOTER //
// ./src/components/hippius/components/Dialog/plugins/index.js